import InfoCircle from "@uui/InfoCircle";

import InfoPanel from "@rui/InfoPanel";
import { Link } from "@rui/Link";

export const ZoomAutomaticallyConnected = () => (
  <InfoPanel
    icon={<InfoCircle />}
    severity="info"
    sx={{ marginTop: 2, width: "100%" }}
    title="Automatically connected via SSO"
  >
    Because you connected Zoom SSO, your Zoom Calendar was automatically
    connected.
  </InfoPanel>
);

export const EditPermissionsRequiredAlert = ({
  displayName,
  onClickReauthorize,
}: {
  displayName: string;
  onClickReauthorize: () => void;
}) => (
  <InfoPanel severity="error" sx={{ mt: 2 }} title="Authorization required">
    {displayName} requires additional permissions to automatically generate
    event links with Read Smart Scheduler.{" "}
    <Link variant="bodySecondaryMed" onClick={onClickReauthorize}>
      Click to Authorize
    </Link>
    .
  </InfoPanel>
);
